Object.defineProperties(exports, {
    __esModule: {
        value: true
    },
    [Symbol.toStringTag]: {
        value: 'Module'
    }
});
var require_runtime = require('./_virtual/_rolldown/runtime.cjs');
var require_attachShareScopeMap = require('./attachShareScopeMap.cjs');
var require_remotes = require('./remotes.cjs');
var require_consumes = require('./consumes.cjs');
var require_initializeSharing = require('./initializeSharing.cjs');
var require_installInitialConsumes = require('./installInitialConsumes.cjs');
var require_initContainerEntry = require('./initContainerEntry.cjs');
var require_init = require('./init.cjs');
var require_getSharedFallbackGetter = require('./getSharedFallbackGetter.cjs');
var _module_federation_runtime = require("@module-federation/runtime");
_module_federation_runtime = require_runtime.__toESM(_module_federation_runtime);
//#region src/index.ts
var federation = {
    runtime: _module_federation_runtime,
    instance: void 0,
    initOptions: void 0,
    bundlerRuntime: {
        remotes: require_remotes.remotes,
        consumes: require_consumes.consumes,
        I: require_initializeSharing.initializeSharing,
        S: {},
        installInitialConsumes: require_installInitialConsumes.installInitialConsumes,
        initContainerEntry: require_initContainerEntry.initContainerEntry,
        init: require_init.init,
        getSharedFallbackGetter: require_getSharedFallbackGetter.getSharedFallbackGetter
    },
    attachShareScopeMap: require_attachShareScopeMap.attachShareScopeMap,
    bundlerRuntimeOptions: {}
};
var instance = federation.instance;
var initOptions = federation.initOptions;
var bundlerRuntime = federation.bundlerRuntime;
var bundlerRuntimeOptions = federation.bundlerRuntimeOptions;
//#endregion
exports.attachShareScopeMap = require_attachShareScopeMap.attachShareScopeMap;
exports.bundlerRuntime = bundlerRuntime;
exports.bundlerRuntimeOptions = bundlerRuntimeOptions;
exports.default = federation;
exports.initOptions = initOptions;
exports.instance = instance;
Object.defineProperty(exports, 'runtime', {
    enumerable: true,
    get: function get() {
        return _module_federation_runtime;
    }
}); //# sourceMappingURL=index.cjs.map
